import { render } from "./Overtime_Policy.vue?vue&type=template&id=21b59a4d"
import script from "./Overtime_Policy.vue?vue&type=script&lang=js"
export * from "./Overtime_Policy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__